/** @jsxImportSource @emotion/react */

import { Trash2 } from 'lucide-react';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectActiveObjects, selectFabricManager, selectIsEditingText } from '../../../../store/editor/selectors';
import { IconButton, IconWrapper } from './styles';

export function Delete() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const activeObjects = useSelector(selectActiveObjects);
  const isEditingText = useSelector(selectIsEditingText);

  const onClickDelete = useCallback(() => {
    if (!fabricManager) return;
    const activeObjects = fabricManager.canvas.getActiveObjects();
    fabricManager.canvas.discardActiveObject();
    fabricManager.canvas.remove(...activeObjects);
  }, [fabricManager]);

  useEffect(() => {
    const deleteOnDel = (event: KeyboardEvent) => {
      let isFocused = document.activeElement?.localName === 'input';
      if ((event.key === 'Delete' || event.key === 'Backspace') && !isEditingText && !isFocused) {
        onClickDelete();
      }
    };

    document.addEventListener('keydown', deleteOnDel);
    return () => {
      document.removeEventListener('keydown', deleteOnDel);
    };
  }, [isEditingText, onClickDelete]);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Удалить'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <IconButton onClick={onClickDelete} disabled={activeObjects.length === 0} tabIndex={0}>
          <IconWrapper icon={<Trash2 size={20} strokeWidth={1.5} />} />
        </IconButton>
      </span>
    </UDTippy>
  );
}
